module.exports = __webpack_public_path__ + "img/profiling-mobile-progress-footer.850eb6bd.png";